import axios from "axios";

const store = {
  state: {
    settings: [],
  },

  getters: {
    getSetting(state) {
      return state.settings;
    },
  },

  mutations: {
    settingsMutation(state, settings) {
      state.settings = settings;
    },
  },

  actions: {
    settingsAction({ commit }, countryId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/setting/country/${countryId}`)
          .then((res) => {
            commit("settingsMutation", res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },


    findLocations() {
      return new Promise((resolve, reject) => {
        axios.get(`/location/select`).then((res) => {
          resolve(res.data);
        }).catch((err) => {
          reject(err)
        })
      })
    }
  },
};

export default store;
